import { BAREME_IRPP_LEGAL, type TrancheIRPP } from './ParametresPaieDates';

export type { TrancheIRPP };

/**
 * Barème IRPP légal (CGI art. 173-174) : source unique = table de paramètres datés
 * (`ParametresPaieDates.ts`). Ce nom n'est conservé que comme alias de lecture.
 */
export const BAREME_IRPP_2026: readonly TrancheIRPP[] = BAREME_IRPP_LEGAL;

/**
 * Parts fiscales — alignées sur les bulletins Sophie / Dusk 2026
 * (célibataire 1 enfant = 2,0 ; marié 3 enfants = 3,5 ; plafond 5).
 * Chaque enfant : +0,5. Parent isolé : +0,5.
 */
export const PARTS_FISCALES = {
  CELIBATAIRE: 1,
  MARIE: 2,
  ENFANT: 0.5,
  /** Conservé pour compat : même valeur que ENFANT (plus de +1 dès le 3ᵉ). */
  ENFANT_DES_LE_TROISIEME: 0.5,
  PARENT_ISOLE_ENFANT: 0.5,
  /** Sophie SM : 9 enfants → 4,5 parts (6 enfants comptés + isolé). */
  ENFANTS_MAX_COMPTES: 6,
  MAX_PARTS: 5,
} as const;
